import Caches from "./caches.vue"
export default  Caches
